(() => {
  'use strict';
  function initHero(hero) {
    if (hero.dataset.ready) return;
    hero.dataset.ready = 'true';
    const video = hero.querySelector('video');
    const toggle = hero.querySelector('[data-motion-toggle]');
    if (!video || !toggle) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let requested = false, interactionPaused = false, inView = false, failed = false, disposed = false, observer;
    video.loop = true;
    const update = () => {
      const paused = video.paused;
      toggle.setAttribute('aria-label', paused ? toggle.dataset.resumeLabel : toggle.dataset.pauseLabel);
      toggle.querySelector('[data-motion-label]').textContent = paused ? toggle.dataset.playingLabel : toggle.dataset.pausedLabel;
      toggle.querySelector('[data-motion-icon]').textContent = paused ? '▷' : 'Ⅱ';
    };
    const fallback = () => { video.pause(); video.classList.remove('is-playing'); toggle.hidden = true; };
    const play = () => {
      if (disposed || failed || interactionPaused || !inView || reduced.matches || navigator.connection?.saveData || document.hidden) return;
      if (!requested) { video.src = video.dataset.src; requested = true; }
      video.muted = true;
      video.play().catch(error => {
        // A deliberate pause during loading aborts play without making the film unavailable.
        if (!disposed && error.name !== 'AbortError') fallback();
      });
    };
    video.addEventListener('playing', () => {
      if (disposed || reduced.matches || navigator.connection?.saveData) return fallback();
      if (interactionPaused || !inView || document.hidden) { video.pause(); return; }
      video.classList.add('is-playing'); toggle.hidden = false; update();
    });
    video.addEventListener('pause', update);
    video.addEventListener('error', () => { failed = true; fallback(); });
    toggle.addEventListener('click', () => {
      interactionPaused = !video.paused;
      if (interactionPaused) video.pause(); else play();
      update();
    });
    hero.querySelector('home-vehicle-finder')?.addEventListener('focusin', () => { interactionPaused = true; video.pause(); });
    const visibility = () => { if (document.hidden) video.pause(); else play(); };
    const motionChange = () => { if (reduced.matches) fallback(); else play(); };
    document.addEventListener('visibilitychange', visibility);
    reduced.addEventListener('change', motionChange);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        for (const entry of entries) { inView = entry.isIntersecting && entry.intersectionRatio >= .15; if (!inView) video.pause(); else play(); }
      }, { threshold: .15 });
      observer.observe(hero);
    } else { inView = true; play(); }
    hero.cleanup = () => {
      disposed = true; observer?.disconnect(); video.pause(); video.removeAttribute('src'); video.load();
      document.removeEventListener('visibilitychange', visibility); reduced.removeEventListener('change', motionChange);
    };
  }
  const init = (scope = document) => scope.querySelectorAll('[data-atelier-hero]').forEach(initHero);
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-atelier-hero]').forEach(hero => hero.cleanup?.()));
})();
